import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../Navbar'
import PageTitle from '../pagetitle'
import BookingForm from '../BookingForm'
import Footer from '../footer'
import Scrollbar from '../scrollbar'
import assessmentImg from '../../images/service/service/Assesments subservice.jpg'
import certificateImg from '../../images/service/service-sub-pages/Assesments.jpg'
import banner7 from '../../images/banners/7.webp'
import './style.css'

const Assessments = () => {
    const ClickHandler = (e) => {
        const hash = e.currentTarget.hash;
        if (hash === '#booking-form') {
            e.preventDefault();
            const element = document.getElementById('booking-form');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo(10, 0);
        }
    }

    return (
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Assessments & Certification'} pagesub={'Service'} backgroundImage={banner7} hideText={true}/>
            <section className="service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8 col-md-12 col-12">
                            <div className="service-single-content">
                                <div className="service-single-img">
                                    <img src={assessmentImg} alt="Assessments and Certification"/>
                                </div>
                                <h2 className="service-title">Assessments & Certification</h2>
                                <div className="service-description">
                                    <p>At Dar-ul-Quran Academy, we believe in recognizing and celebrating progress. Our comprehensive assessment and certification system is designed to track student development, provide constructive feedback, and formally acknowledge achievements. This structured approach helps students stay motivated and provides clear evidence of their growing Quranic skills.</p>
                                </div>
                                
                                <div className="service-single-inner">
                                    <span><img src={certificateImg} alt="Quran Learning Certificate"/></span>
                                    <div className="service-single-tb-text">
                                        <h3 className="service-section-title"><i className="fi flaticon-diploma"></i> Regular Progress Checks</h3>
                                        <p>Our assessment system includes:</p>
                                        <ul className="service-features-list">
                                            <li>Ongoing informal evaluations during each lesson</li>
                                            <li>Scheduled recitation tests to measure fluency and accuracy</li>
                                            <li>Short written or oral quizzes on theoretical aspects of Tajweed</li>
                                            <li>Monthly progress summaries for parents and students</li>
                                            <li>Termly formal assessments with detailed feedback</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-idea"></i> Our Assessment Philosophy</h3>
                                    <div className="service-section-content">
                                        <p>We take a balanced approach to student evaluation:</p>
                                        <ul className="service-features-list">
                                            <li>Assessments are designed to encourage, not intimidate</li>
                                            <li>Progress is measured against the individual's previous performance, not just against standard benchmarks</li>
                                            <li>We recognize different learning paces and styles</li>
                                            <li>Feedback focuses on specific achievements and constructive guidance for improvement</li>
                                            <li>Assessments are tailored to each course level and student age group</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-certificate"></i> Certification Program</h3>
                                    <div className="service-section-content">
                                        <p>Upon completing course levels or achieving significant milestones, students receive:</p>
                                        <ul className="service-features-list">
                                            <li>Personalized digital certificates with the student's name and specific achievements</li>
                                            <li>Recognition of course completion with level indication</li>
                                            <li>Special certificates for memorization achievements (e.g., completing Juz Amma, multiple juz, or the entire Quran)</li>
                                            <li>Documentation of Tajweed mastery with detailed competency notes</li>
                                            <li>Official academy seal and tutor endorsement</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-report"></i> Parent Reports</h3>
                                    <div className="service-section-content">
                                        <p>We keep parents fully informed about their child's progress:</p>
                                        <ul className="service-features-list">
                                            <li>Regular digital reports detailing achievements and areas for focus</li>
                                            <li>Parent-teacher meetings available upon request</li>
                                            <li>Practical suggestions for supporting learning at home</li>
                                            <li>Clear explanations of assessment criteria and expectations</li>
                                            <li>Guidance on appropriate next steps in the learning journey</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-award"></i> Recognition & Advancement</h3>
                                    <div className="service-section-content">
                                        <p>Our certification system offers several benefits:</p>
                                        <ul className="service-features-list">
                                            <li>Motivates students through recognition of their hard work</li>
                                            <li>Provides tangible evidence of achievements for educational portfolios</li>
                                            <li>Helps track long-term progress across multiple courses</li>
                                            <li>Builds confidence through formal acknowledgment of skills</li>
                                            <li>Creates memorable milestones in the student's Quranic journey</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-conclusion">
                                    <p>We understand that measuring progress is essential for effective learning. Our structured assessment and certification system helps students recognize their growth, celebrate achievements, and maintain motivation for continued study. Rather than creating pressure, our approach emphasizes the joy of advancement and the satisfaction of mastering new skills in Quranic studies.</p>
                                </div>
                                
                                <div className="btns text-center mt-5">
                                    <Link onClick={ClickHandler} to="/home#booking-form" className="theme-btn">Contact Us to Learn More</Link>
                                </div>
                            </div>
                            
                            <div className="prv-nx">
                                <div className="pre-btn"><Link onClick={ClickHandler} to="/free-demo">Previous: Free Demo Class</Link></div>
                                <div className="nex-btn"><Link onClick={ClickHandler} to="/basic-qaida">Next: Basic Qaida</Link></div>
                            </div>
                        </div>
                        
                        <div className="col col-lg-4 col-md-12 col-12">
                            <div className="service-sidebar">
                                <div className="widget service-list-widget">
                                    <h3>All Services</h3>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/basic-qaida">Basic Qaida (Beginner Quran Reading)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed">Tajweed (Quran Recitation Rules)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed-improvement">Tajweed Improvement (Advanced)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/hifz">Hifz (Quran Memorisation)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/class-options">Class Options</Link></li>
                                        <li><Link onClick={ClickHandler} to="/free-demo">Free Demo Class</Link></li>
                                        <li className="current"><Link to="/assessments">Assessments & Certification</Link></li>
                                    </ul>
                                </div>
                                <div className="widget contact-widget">
                                    <div>
                                        <h4>Start Your Quran Learning Journey</h4>
                                        <h2><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BookingForm/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
}

export default Assessments; 